(function ($) {
  var speed = 1500; // ms time of animation duration
  var delay = 500; // ms for next function to run

  var nextStart = speed - delay;

  var Counters = [];

  $('.ys-events-calendar__counter__number').each(function (index) {
    Counters[index] = {
      element: $(this),
      max: $(this).data('max'),
      started: false,
    };
  });

  if (Counters.length < 1) {
    return;
  }

  // Function to start counting a counter
  function animateCounter(index) {
    if (typeof Counters[index] === 'undefined') {
      return;
    }

    Counters[index].started = true;

    var nextIndex = index + 1;

    $({ Counter: 0 }).animate(
      { Counter: Counters[index].max },
      {
        duration: speed,
        easing: 'swing',
        step: function (number) {
          Counters[index].element.text(Math.ceil(number));
        },
        progress: function (animation, progress, remaining) {
          if (
            typeof Counters[nextIndex] === 'undefined' ||
            Counters[nextIndex].started === true ||
            remaining > nextStart
          ) {
            return;
          }

          animateCounter(nextIndex);
        },
      }
    );
  }

  // Start the chain reaction
  animateCounter(0);
})(jQuery);

(function ($) {
  if ($('.ys-events-calendar').length < 1) {
    return;
  }

  if (typeof ImageStretch === 'function') {
    new ImageStretch({
      watched: [
        {
          selector:
            '.ys-events-calendar__featured-banner .image-holder, .ys-events-calendar__banner .image-holder',
        },
      ],
    });
  }
})(jQuery);

(function ($) {
  if ($('.ys-events-calendar').length < 1) {
    return;
  }

  var wrapper = $('.ys-events-calendar__banners__more-wrapper');
  var showMoreButton = $(
    'button.ys-events-calendar__banners__show-more__toggle-button'
  );
  var showMoreText = showMoreButton.data('more');
  var showLessText = showMoreButton.data('less');

  showMoreButton.click(function (e) {
    e.preventDefault();

    wrapper.slideToggle('medium', function () {
      if ($(this).is(':visible')) {
        $(this).css('display', 'flex');
        showMoreButton.find('span').text(showLessText);
        if (typeof ImageStretch === 'function') {
          new ImageStretch({
            watched: [
              {
                selector:
                  '.ys-events-calendar__banners__more-wrapper .image-holder',
              },
            ],
          });
        }
      } else {
        showMoreButton.find('span').text(showMoreText);
      }
    });
  });
})(jQuery);

(function ($) {
  if ($('.ys-events-calendar').length < 1) {
    return;
  }

  var overlay = $('.ys-events-calendar__overlay');

  var eventsCalendarElement = $('.ys-events-calendar');
  var Events = [];
  var Countries = eventsCalendarElement.data('countries');

  var currentEventId = 0;
  var currentCountryId = 0;
  var currentEventBlogId = 0;

  var labelLocation = eventsCalendarElement.data('label-location');
  var labelDate = eventsCalendarElement.data('label-date');
  var labelLength = eventsCalendarElement.data('label-length');
  var countryLabels = eventsCalendarElement.data('country-labels');

  var overlayBannerElement = $('.ys-events-calendar__overlay__banner');
  var overlayTable = $('.ys-events-calendar__overlay__event-table');

  var moreLabel = overlayTable.data('more');
  var lessLabel = overlayTable.data('less');

  var defaultBanner = window.eventsCalendar.defaultBanner;

  function closeOverlay() {
    overlay.addClass('ys-closed');
  }

  function openOverlay() {
    overlay.removeClass('ys-closed');

    // Wait until overlay animation finished to make sure banner is at the right size before stretching
    setTimeout(function () {
      if (typeof ImageStretch === 'function') {
        new ImageStretch({
          watched: [
            { selector: '.ys-events-calendar__overlay__banner.image-holder' },
          ],
        });
      }
    }, 3000);
  }

  function ajaxEvent(eventId, blogId) {
    return $.ajax({
      method: 'GET',
      url:
        window.ys.rest_url +
        'calendar-events/v1/event/' +
        blogId +
        '/' +
        eventId,
    });
  }

  function ajaxEvents(events) {
    return $.ajax({
      method: 'POST',
      url: window.ys.rest_url + 'calendar-events/v1/events/',
      data: { events: events },
    });
  }

  // Promise that is used to fetch event via Ajax
  var getEvent = function (id, blogId) {
    return new Promise(function (returnEvent, reject) {
      if (typeof Events[blogId] === 'undefined') {
        Events[blogId] = [];
      }
      if (typeof Events[blogId][id] === 'undefined') {
        ajaxEvent(id, blogId).done(function (response) {
          if (typeof response.data !== 'undefined') {
            Events[blogId][id] = response.data;
            returnEvent(Events[blogId][id]);
          } else {
            reject();
          }
        });
      } else {
        returnEvent(Events[blogId][id]);
      }
    });
  };

  // Promise that is used to fetch events of a country by ID
  var getMultipleEvents = function (events) {
    return new Promise(function (returnEvent, reject) {
      ajaxEvents(events).done(function (response) {
        if (typeof response.events !== 'undefined') {
          returnEvent(response.events);
        } else {
          reject();
        }
      });
    });
  };

  // Promise that is used to fetch events of a country by ID
  var fetchCountryEvents = function (countryEvents) {
    return new Promise(function (returnEventIds, reject) {
      var fetchEvents = [];

      $.each(countryEvents, function (index, countryEvent) {
        var eventId = countryEvent.id;
        var blogId = countryEvent.blogId;

        if (typeof Events[blogId] === 'undefined') {
          Events[blogId] = [];
        }

        if (typeof Events[blogId][eventId] === 'undefined') {
          fetchEvents.push(countryEvent);
        }
      });

      if (fetchEvents.length === 0) {
        returnEventIds(countryEvents);
        return;
      }

      getMultipleEvents(fetchEvents)
        .then(function (responseObjects) {
          $.each(responseObjects, function (eventId, eventObject) {
            Events[eventObject.blogId][eventId] = eventObject;
          });

          returnEventIds(countryEvents);
        })
        .catch(function () {
          reject();
        });
    });
  };

  function getCountryId(countryName) {
    if (countryName.indexOf(', ') >= 0) {
      countryName = countryName.substr(0, countryName.indexOf(', '));
    }

    return $.each(Countries, function (countryId, countryObject) {
      if (countryObject.name === countryName) {
        return countryId;
      }
    });
  }

  function createEventsTableWithHead(tableClass, eventClass) {
    var $table = $('<table/>', { class: tableClass });
    var $thead = $('<thead/>');
    var $headerRow = $('<tr/>');

    $headerRow.append(
      $('<th/>', { class: tableClass + '__name', text: eventClass })
    );
    $headerRow.append(
      $('<th/>', { class: tableClass + '__location', text: labelLocation })
    );
    $headerRow.append(
      $('<th/>', { class: tableClass + '__date', text: labelDate })
    );
    $headerRow.append(
      $('<th/>', { class: tableClass + '__length', text: labelLength })
    );

    $thead.append($headerRow);
    $table.append($thead);

    return $table;
  }

  // Promise that is used to setup overlay contents
  var setupOverlayData = function (EventObject, isUpcoming) {
    return new Promise(function (resolve, reject) {
      var upcomingDateElement = $(
        '.ys-events-calendar__overlay__upcoming-date'
      );
      var eventLocation = countryLabels[EventObject.country];
      if (EventObject.location && EventObject.location.trim() !== '') {
        eventLocation = EventObject.location;
      }

      if (isUpcoming) {
        $('.ys-events-calendar__overlay__upcoming').addClass('ys-show');
        upcomingDateElement.removeClass('ys-show');
      } else {
        $('.ys-events-calendar__overlay__upcoming').removeClass('ys-show');
        upcomingDateElement.html(EventObject.date);
        upcomingDateElement.addClass('ys-show');
      }

      $('.ys-events-calendar__overlay__country').html(eventLocation);
      $('.ys-events-calendar__overlay__title').html(EventObject.name);
      $('.ys-events-calendar__overlay__description').html(EventObject.excerpt);

      var websiteElement = $('.ys-events-calendar__overlay__website');

      if (EventObject.website === null) {
        websiteElement.hide();
      } else {
        var websiteText = EventObject.website;
        if (
          typeof EventObject.websiteText !== 'undefined' &&
          EventObject.websiteText !== ''
        ) {
          websiteText = EventObject.websiteText;
        }

        websiteElement.html(
          '<a href="' +
            EventObject.website +
            '" target="_blank">' +
            websiteText +
            '</a>'
        );
        websiteElement.show();
      }

      if (
        typeof EventObject.banner === 'undefined' ||
        EventObject.banner === 'default' ||
        EventObject.banner === ''
      ) {
        if (typeof defaultBanner !== 'undefined' && defaultBanner !== '') {
          overlayBannerElement.html(
            '<img src="' + defaultBanner + '" alt="' + EventObject.name + '">'
          );
          overlayBannerElement.show();
          if (typeof ImageStretch === 'function') {
            new ImageStretch({
              watched: [
                {
                  selector: '.ys-events-calendar__overlay__banner.image-holder',
                },
              ],
            });
          }
        } else {
          overlayBannerElement.hide();
        }
      } else {
        overlayBannerElement.html(
          '<img src="' +
            EventObject.banner +
            '" alt="' +
            EventObject.name +
            '">'
        );
        overlayBannerElement.show();

        if (typeof ImageStretch === 'function') {
          new ImageStretch({
            watched: [
              { selector: '.ys-events-calendar__overlay__banner.image-holder' },
            ],
          });
        }
      }

      $('.ys-events-calendar__overlay__event-table').html('');

      var countryEvents = Countries[EventObject.country].events;

      fetchCountryEvents(countryEvents)
        .then(function (countryEventIds) {
          var eventClasses = {};
          var eventClassesTranslations = {};

          var highlightsCount = 0;

          var $highlightsGallery = $(
            '.ys-events-calendar__overlay__highlights__gallery'
          );
          $highlightsGallery.html('');

          $.each(countryEventIds, function (index, eventDefinition) {
            var eventId = eventDefinition.id;
            var blogId = eventDefinition.blogId;
            var eventObject = Events[blogId][eventId];

            var eventClass = eventObject.class;
            var eventClassLabel = eventObject.classLabel;

            if (typeof eventClasses[eventClass] === 'undefined') {
              eventClasses[eventClass] = [];
              eventClassesTranslations[eventClass] = eventClassLabel;
            }

            if (
              highlightsCount < 6 &&
              eventId !== currentEventId &&
              eventObject.featured !== '' &&
              eventObject.featured !== false
            ) {
              var $highlightItemImage = $('<img/>', {
                src: eventObject.featured,
                alt: eventObject.name,
              });
              var $highlightsItem = $('<div/>', {
                class:
                  'ys-events-calendar__overlay__highlights__item image-holder',
                'data-id': eventId,
                'data-blog-id': blogId,
              });

              $highlightsItem.append($highlightItemImage);
              $highlightsGallery.append($highlightsItem);
              highlightsCount++;
            }

            eventClasses[eventClass].push({ blogId: blogId, eventId: eventId });
          });

          var tableClass = 'ys-events-calendar__table';
          var $eventsTableWrapper = $(
            '.ys-events-calendar__overlay__event-table'
          );
          $eventsTableWrapper.html();

          $.each(eventClasses, function (eventClass, classEventObjects) {
            var $table = createEventsTableWithHead(
              tableClass,
              eventClassesTranslations[eventClass]
            );
            var hasMore = false;

            $.each(classEventObjects, function (index, classEventObj) {
              // If there are more than 3 events, break table off and create a hidden one with more button
              if (index === 3) {
                hasMore = true;

                $eventsTableWrapper.append($table);

                $table = $('<table/>', {
                  class: tableClass + ' ' + tableClass + '--more ys-hidden',
                  'data-class': eventClass,
                });
              }

              var classEventBlogId = classEventObj.blogId;
              var classEventId = classEventObj.eventId;

              var classEvent = Events[classEventBlogId][classEventId];

              var eventLocation = countryLabels[classEvent.country];
              if (classEvent.location && classEvent.location.trim() !== '') {
                eventLocation = classEvent.location;
              }

              var $tableEventBody = $('<tbody/>');
              var $tableEventRow = $('<tr/>');
              var $eventName = $('<td/>', { class: tableClass + '__name' });
              var $raceLink = $('<div/>', {
                class:
                  'ys-events-calendar__race-link ys-events-calendar__overlay-race-link',
                'data-id': classEventId,
                'data-blog-id': classEventBlogId,
                text: classEvent.name,
              });
              $eventName.append($raceLink);
              $tableEventRow.append($eventName);
              $tableEventRow.append(
                $('<td/>', {
                  class: tableClass + '__location',
                  text: eventLocation,
                })
              );
              $tableEventRow.append(
                $('<td/>', {
                  class: tableClass + '__date',
                  text: classEvent.date,
                })
              );
              $tableEventRow.append(
                $('<td/>', {
                  class: tableClass + '__length',
                  text: classEvent.distance,
                })
              );

              $tableEventBody.append($tableEventRow);
              $table.append($tableEventBody);
            });

            $eventsTableWrapper.append($table);

            if (hasMore) {
              var $moreDiv = $('<div/>', {
                class: 'ys-events-calendar__overlay__more',
              });
              var $moreButton = $('<button/>', {
                class:
                  'ys-events-calendar__overlay__more__toggle-button btn-wlc btn-primary',
                type: 'submit',
                'data-class': eventClass,
              });
              var $moreButtonSpan = $('<span/>', { text: moreLabel });

              $moreButton.append($moreButtonSpan);
              $moreDiv.append($moreButton);
              $eventsTableWrapper.append($moreDiv);
            }

            $eventsTableWrapper.append(
              $('<div/>', { class: 'ys-events-calendar__overlay-table-spacer' })
            );
          });

          if (highlightsCount === 0) {
            $('.ys-events-calendar__overlay__highlights').addClass('ys-hide');
          } else {
            $('.ys-events-calendar__overlay__highlights.ys-hide').removeClass(
              'ys-hide'
            );
          }

          resolve();
        })
        .catch(function () {
          reject();
        });
    });
  };

  function getUpcomingEventId(countryId) {
    if (
      typeof Countries[countryId] === 'undefined' ||
      typeof Countries[countryId].upcoming === 'undefined'
    ) {
      return null;
    }

    return Countries[countryId].upcoming.id;
  }

  function getUpcomingEventBlogId(countryId) {
    if (
      typeof Countries[countryId] === 'undefined' ||
      typeof Countries[countryId].upcoming === 'undefined'
    ) {
      return null;
    }

    return Countries[countryId].upcoming.blogId;
  }

  function setCurrentCountryId(countryId) {
    currentCountryId = countryId;
  }

  function setCurrentEventId(eventId) {
    currentEventId = eventId;
  }

  function setCurrentEventBlogId(blogId) {
    currentEventBlogId = blogId;
  }

  // For links that are printed via backend
  $('.ys-events-calendar__race-link, .ys-events-calendar__banner__wrap').click(
    function (e) {
      var $this = $(this);
      $this.addClass('loading');

      var eventId = $(this).data('id');
      var blogId = $(this).data('blog-id');

      getEvent(eventId, blogId).then(function (EventObject) {
        setCurrentCountryId(EventObject.country);
        setCurrentEventId(eventId);
        setCurrentEventBlogId(blogId);

        setupOverlayData(EventObject, false)
          .then(function (e) {
            openOverlay();
            $this.removeClass('loading');
          })
          .catch(function () {
            $this.removeClass('loading');
          });
      });
    }
  );

  // For popup links that are generated via script
  $(document).on(
    'click',
    '.ys-events-calendar__overlay-race-link, .ys-events-calendar__overlay__highlights__item',
    function (e) {
      var $this = $(this);
      $this.addClass('loading');

      var eventId = $(this).data('id');
      var blogId = $(this).data('blog-id');

      getEvent(eventId, blogId).then(function (EventObject) {
        setCurrentCountryId(getCountryId(EventObject.country));
        setCurrentEventId(eventId);
        setCurrentEventBlogId(blogId);

        setupOverlayData(EventObject, false)
          .then(function (e) {
            openOverlay();
            $this.removeClass('loading');
          })
          .catch(function () {
            $this.removeClass('loading');
          });
      });
    }
  );

  $('.ys-events-calendar__country').click(function (e) {
    var $this = $(this);
    $this.addClass('loading');

    var countryId = $(this).data('country');

    setCurrentCountryId(countryId);
    setCurrentEventId(getUpcomingEventId(countryId));
    setCurrentEventBlogId(getUpcomingEventBlogId(countryId));

    if (currentEventBlogId === null || currentEventId === null) {
      $this.removeClass('loading');
      return;
    }

    getEvent(currentEventId, currentEventBlogId)
      .then(function (EventObject) {
        setupOverlayData(EventObject, true)
          .then(function (e) {
            openOverlay();
            $this.removeClass('loading');
          })
          .catch(function () {
            $this.removeClass('loading');
          });
      })
      .catch(function () {
        $this.removeClass('loading');
      });
  });

  $('button.ys-events-calendar__overlay__close-button').click(function (e) {
    closeOverlay();
  });

  $(document).on(
    'click',
    '.ys-events-calendar__overlay__more__toggle-button',
    function (e) {
      var $this = $(this);
      var eventClass = $this.data('class');
      var classTableElement = $(document).find(
        '.ys-events-calendar__table--more[data-class="' + eventClass + '"]'
      );

      classTableElement.toggleClass('ys-hidden');
      $this.toggleClass('btn-dark');
      if ($this.hasClass('btn-dark')) {
        $this.html(lessLabel);
      } else {
        $this.html(moreLabel);
      }
    }
  );

  $(document).ready(function () {
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    if (!urlParams.has('event')) {
      return;
    }
    var eventId = urlParams.get('event');
    var blogId = $('.ys-events-calendar__table-section')
      .find(".ys-events-calendar__race-link[data-id='" + eventId + "']")
      .data('blog-id');

    getEvent(eventId, blogId).then(function (EventObject) {
      setCurrentCountryId(EventObject.country);
      setCurrentEventId(eventId);
      setCurrentEventBlogId(blogId);

      setupOverlayData(EventObject, false).then(function (e) {
        openOverlay();
      });
    });
  });
})(jQuery);

(function ($) {
  if ($('.ys-events-calendar').length < 1) {
    return;
  }

  var tableShowMoreWrapper = $('.ys-events-calendar__table__show-more');
  var tableShowMoreButton = $(
    'button.ys-events-calendar__table__more__toggle-button'
  );
  var showMoreText = tableShowMoreButton.data('more');
  var showLessText = tableShowMoreButton.data('less');

  tableShowMoreButton.click(function (e) {
    var theId = $(this).attr('data-class');
    e.preventDefault();

    var thisButton = $(this);

    $(
      ".ys-events-calendar__table__show-more[data-class='" + theId + "']"
    ).toggle('instant', function () {
      if ($(this).is(':visible')) {
        $(this).css('display', 'table-row');
        thisButton.find('span').text(showLessText);
      } else {
        thisButton.find('span').text(showMoreText);
      }
    });
  });
})(jQuery);
